import { FormSchema } from '../../../types/formSchema';
import { NETPPM_PERIOD_TREE_DATA, DEFAULT_NETPPM_PERIOD, DEFAULT_SCENARIO, SCENARIO_WEEKLY } from '../../../constants/netppm-constants';
import { WORKFLOW_TAGS } from '../../../constants/workflow-tags';

export const netppmFormSchema: FormSchema = {
  id: 'netppm-create',
  title: `Create ${WORKFLOW_TAGS.PPM.label} Workflow`,
  description: `Configure your ${WORKFLOW_TAGS.PPM.label} workflow settings below`,
  sections: [
    {
      title: 'Basic Settings',
      description: 'Configure the basic information for your workflow',
      layout: 'single-column',
      fields: [
        {
          type: 'text',
          name: 'name',
          label: 'Workflow Name',
          placeholder: 'Enter a name for this workflow',
          validation: [
            { required: true, message: 'Workflow Name is required' }
          ],
          componentProps: {
            allowClear: true,
            showCount: true,
            maxLength: 100
          }
        },
        {
          type: 'textarea',
          name: 'description',
          label: 'Workflow Description',
          placeholder: 'Provide a description for this workflow',
          componentProps: {
            allowClear: true,
            showCount: true,
            maxLength: 500,
            autoSize: { minRows: 3, maxRows: 6 }
          }
        }
      ]
    },
    {
      title: 'Workflow Scope',
      description: 'Configure the scope of data to include in your report',
      layout: 'two-column',
      fields: [
        {
          type: 'dropdown',
          name: 'region',
          label: 'Region',
          defaultValue: 'US',
          options: [
            { value: 'US', label: 'US' },
            { value: 'Canada', label: 'Canada' },
            { value: 'Europe', label: 'Europe', disabled: true },
            { value: 'International Stores Finance', label: 'International Stores Finance', disabled: true }
          ],
          validation: [
            { required: true, message: 'Region is required' }
          ]
        },
        {
          type: 'dropdown',
          name: 'product_family',
          label: 'Product Family',
          placeholder: 'Select Product Family...',
          options: [
            { value: 'BEATS', label: 'BEATS' },
            { value: 'Books', label: 'Books' },
            { value: 'Consumables', label: 'Consumables' },
            { value: 'DVD', label: 'DVD' },
            { value: 'Fashion & Fitness', label: 'Fashion & Fitness' },
            { value: 'Home & Lifestyle', label: 'Home & Lifestyle' },
            { value: 'Music', label: 'Music' }
          ],
          validation: [
            { required: true, message: 'Product Family is required' }
          ]
        },
        {
          type: 'dropdown',
          name: 'gl_code',
          label: 'GL',
          placeholder: 'Select Product Family first...',
          options: []
        },
        {
          type: 'dropdown',
          name: 'deep_dive_dimension',
          label: 'Deep Dive Dimension',
          defaultValue: 'rate_mix',
          options: [
            { value: 'rate_mix', label: 'Rate & Mix' },
            { value: 'sourcing_channel_fc_type', label: 'Sort Type / Sourcing Channel' },
            { value: 'premium_everyday_private', label: 'Everyday Essentials / Premium Selection / Amazon Private Brands' },
            { value: 'gv_velocity', label: 'GV Velocity' }
          ],
          validation: [
            { required: true, message: 'Deep Dive Dimension is required' }
          ]
        },
        {
          type: 'treeSelect',
          name: 'period',
          label: 'Period',
          placeholder: 'Select period...',
          treeDefaultExpandAll: false,
          treeData: NETPPM_PERIOD_TREE_DATA,
          defaultValue: DEFAULT_NETPPM_PERIOD,
          validation: [
            { required: true, message: 'Period is required' }
          ]
        }
      ]
    },
    {
      title: 'Analysis Settings',
      description: `Configure the analysis parameters for your ${WORKFLOW_TAGS.PPM.label} workflow`,
      layout: 'single-column',
      fields: [
        {
          type: 'dropdown',
          name: 'scenarios',
          label: 'Scenarios',
          defaultValue: DEFAULT_SCENARIO,
          options: [
            { value: DEFAULT_SCENARIO, label: DEFAULT_SCENARIO },
            { value: 'YTD - Actuals vs Prior Year', label: 'YTD - Actuals vs Prior Year' },
            { value: SCENARIO_WEEKLY, label: SCENARIO_WEEKLY }
          ],
          validation: [
            { required: true, message: 'Scenarios is required' }
          ]
        }
      ]
    }
  ]
};
